<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>

    <div v-else>
      <v-card flat>
        <PrintViewBar v-if="customer" :showEmailBtn="showEmailBtn" :id="customer.id" type="invoice"
          title="Open Invoie List" :postfix="`openInvoice?key=${currentBusiness.code}`" :name="currentBusiness.name"
          :email="customer.email" :obj="customer" :text="`${currentBusiness.name} Invoice click here to view`" />

        <v-container grid-list-lg>
          <v-card-text class="pb-0">
            <v-layout row wrap>
              <v-flex class="text-left text-capitalize">
                <div v-if="!$vuetify.breakpoint.xsOnly">
                  <img class="logo" :src="currentBusiness.imageUrl" alt="" />
                </div>
                <div class=" headline font-weight-bold">
                  {{ currentBusiness.name }}
                </div>
                <div class="font-weight-medium">
                  {{ currentBusiness.address }} {{ currentBusiness.city }},
                  <span class="text-uppercase">{{ currentBusiness.state }}
                  </span>
                  {{ currentBusiness.zip }}
                </div>
                <div class="font-weight-medium">
                  {{ currentBusiness.phoneNumber }}
                </div>
                <div class="font-weight-medium text-lowercase">
                  {{ currentBusiness.email }}
                </div>
                <div class="font-weight-medium text-lowercase">
                  {{ currentBusiness.website }}
                </div>
                <!-- <div v-if="!$vuetify.breakpoint.xsOnly" class="mt-1 display-3 font-weight-black blue--text">
                  OPEN INVOICE
                </div>
                <div v-else class="mt-1 display-1 font-weight-black blue--text">
                  OPEN INVOICE
                </div> -->
                <br />

                <span class="font-weight-bold mt-10">Date:</span> {{ currentDate | moment("MMM DD YYYY") }}

                <!-- <div class="font-weight-regular">
                  <div class="font-weight-medium">BILL TO</div>
                  <div>{{ customer.name }}</div>
                  <div>{{ customer.address }}</div>
                  <div v-if="customer.city">
                    {{ customer.city }},<span class="text-uppercase">{{ customer.state }}
                    </span>
                    {{ customer.zip }}
                  </div>
                </div>
                <br /> -->
              </v-flex>

              <v-spacer></v-spacer>

              <!-- <v-flex shrink class="text-right">
                <div v-if="!$vuetify.breakpoint.xsOnly">
                  <img class="logo" :src="currentBusiness.imageUrl" alt="" />
                </div>
                <div >
                  <v-layout row wrap>
                    <v-spacer></v-spacer>
                    <v-flex shrink>
                      <div class="headline font-weight-medium text-right blue--text">
                        BALANCE
                      </div>
                      <div class="display-2 font-weight-light text-right">
                        {{ customer.balance | currency }}
                      </div>
                      <br />
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex> -->
            </v-layout>
          </v-card-text>
          <v-card-text class="body-1 font-weight-light">

            <div>Dear <span class="font-weight-bold">{{ customer.fatherName }}</span>,</div>

            <div class="mt-5">
              Parent/Guardian of: <span class="font-weight-bold">{{ formattedStudentNames }}</span>
            </div>

            <div class="mt-5">
              Alhamdulillah your child(ren) are studying in one/some of Muhammadi Masjid educational programs.
              For the smooth running of these programs, we need your financial assistance.
            </div>

            <div class="mt-5">
              According to our records, you have past due balance of <span class="font-weight-bold">{{ customer.balance
                | currency }}/- </span> Please fill out the attached ACH form so that we can resolve this issue. Please
              note that we shred your
              information for safety.
            </div>

            <div class="mt-5">
              If you have any questions or concerns, please contact:
            </div>

            <template v-for="(item, index) in classes">
              <div :key="index">
                {{ item.name }}: <span class="font-weight-bold">{{ stripHTML(item.letterContactInformation) }}</span>
              </div>
            </template>

            <div class="mt-5">
              Please see attached invoice and ACH form.
            </div>

            <div class="mt-5">
              Jazakallah khayran for your assistance
            </div>

            <div class="mt-10 font-weight-bold">
              Muhammadi Masjid Management
            </div>

          </v-card-text>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import PrintViewBar from "@/components/PrintViewBar";

import invoiceService from "@/modules/Invoice/service";
import customerService from "@/modules/Customer/service";
import studentService from "@/modules/Student/service.js";
import Hashids from "hashids";
const hashids = new Hashids();
import { mapGetters, mapActions } from "vuex";

export default {
  name: "pending-invoice",
  data() {
    return {
      currentDate: new Date,
      customer: null,
      showEmailBtn: false,
      isLoading: true,
      business: null,
      students: [],
      classes: [],
      Invoice: null,
      headers: [
        {
          text: "DATE",
          align: "left",
          value: "productDetail",
          sortable: false,
        },
        {
          text: "ID",
          align: "center",
          value: "qty",
          sortable: false,
        },
        {
          text: "AMOUNT",
          align: "right",
          value: "rate",
          sortable: false,
        },
        {
          text: "BALANCE",
          align: "right",
          value: "total",
          sortable: false,
        },
      ],
      totalQty: 0,
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    formattedStudentNames() {
      const names = this.students.map(student => student.fullName);
      if (names.length > 1) {
        return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
      } else {
        return names[0];
      }
    },
  },
  async created() {
    await this.getCustomer();
    await this.getStudents();
    
    if (this.$route.meta.public) {
      await this.loadPublicData();
    } else {
      await this.loadData();
    }
    this.isLoading = false;
    if (!this.currentBusiness) this.initUser();
    document.title = `Report - Pending Balance Letter`;
    // this.initUser();
    // console.log('this.$route.params', this.$route.meta)
  },
  components: { PrintViewBar },
  methods: {
    ...mapActions("global", ["initUser"]),
    viewInvoice(invoice) {
      const hashId = hashids.encode(invoice.id);
      let routeData = null;
      if (this.$route.meta.public) {
        routeData = this.$router.resolve({
          path: `/public/invoice/${hashId}/view`,
        });
      } else {
        routeData = this.$router.resolve({
          path: `/global/invoice/${hashId}/view`,
        });
      }

      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    getCustomer() {
      const id = hashids.decode(this.$route.params.id);
      return customerService.getById(id).then((response) => {
        this.customer = response.data;
        console.log('this.customer', this.customer)
        if (this.customer.email) this.showEmailBtn = true;
      });
    },
    getStudents() {
      console.log('this.customer.id', this.customer.id)
      return studentService.getAll({CustomerId: this.customer.id}).then(async(response) => {
        this.students = response.data;
        console.log('this.students', this.students)
        this.classes = []
        await this.students.map(student => {
          student.ClassStudents.map(async classStudent => {
            let rowFound = this.classes.find(({ id }) => id == classStudent.ClassId);
            if(!rowFound)
              this.classes.push(classStudent.Class)
          })
        })
      });
    },
    print() {
      window.print();
    },
    stripHTML(html) {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      return tempElement.textContent || tempElement.innerText || '';
    },
    loadPublicData() {
      const id = hashids.decode(this.$route.params.id);
      const key = this.$route.query.key;
      const where = {
        CustomerId: id,
        due: true,
        key: key,
      };
      return invoiceService.getAll(where).then((response) => {
        // console.log("response invoice", response);
        this.$Progress.finish();
        this.Invoice = response.data;
      });
    },
    loadData() {
      const id = hashids.decode(this.$route.params.id);

      const where = {
        CustomerId: id,
        due: true,
      };

      return invoiceService.getAll(where).then((response) => {
        console.log("invoice", response);
        this.Invoice = response.data;
        this.count = response.count;
        this.business = response.business;
        return response;
      });

    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .no-print {
    display: none;
  }

  .detailBox {
    overflow: visible;
    height: 100%;
  }

  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}

.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}

.center {
  background-color: white;
  margin: auto;
  width: 100%;
}

/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
